<button
  type="button"
  class="btn btn-outline-secondary"
  (click)="onButtonClick()"
>
  {{ isPaused ? 'Resume' : 'Pause' }} <i class="fas fa-regular" [ngClass]="isPaused ? 'fa-play' : 'fa-pause'"></i>
</button>
